module.exports = __webpack_public_path__ + "assets/fa-solid-900.bea989e82b07e9687c26fc58a4805021.woff";